import { gql } from '@apollo/client';
import { Fragments } from 'api/fragments';

export const GET_RULES = gql`
  query getRules {
    scrubbingRules {
      ...ScrubbingRule
    }
  }

  ${Fragments.ScrubbingRule}
`;

export const ADD_RULE = gql`
  mutation addRule($scrubbingRule: ScrubbingRuleRequestBodyInput!) {
    addScrubbingRule(scrubbingRule: $scrubbingRule) {
      ...ScrubbingRule
    }
  }

  ${Fragments.ScrubbingRule}
`;

export const UPDATE_RULE = gql`
  mutation updateRule($id: ID!, $scrubbingRule: ScrubbingRuleRequestBodyInput!) {
    updateScrubbingRule(id: $id, scrubbingRule: $scrubbingRule) {
      ...ScrubbingRule
    }
  }

  ${Fragments.ScrubbingRule}
`;

export const DELETE_RULE = gql`
  mutation deleteRule($id: ID!) {
    deleteScrubbingRule(id: $id)
  }
`;

export const MOVE_RULE = gql`
  mutation moveRule($id: ID!, $position: Int!) {
    moveScrubbingRule(id: $id, position: $position) {
      ...ScrubbingRule
    }
  }

  ${Fragments.ScrubbingRule}
`;
